import { type FC } from "react";
import { SimpleMenu } from "~/common/components/Menu/Menu";
import { MENU_POS_LEFT } from "~/common/components/Menu/MenuPositions";
import { MenuItem } from "~/common/components/Menu/MenuItem";
import { useTranslation } from "react-i18next";

interface Props {
  onClose: () => void;
  anchorEl: Element | null;
  isOpen: boolean;
  shareConfigurationsViaSalesPartnerFinder: () => void;
  shareConfigurationsViaEmail: () => void;
}

const ShareConfigurationsMenu: FC<Props> = ({
  onClose,
  anchorEl,
  isOpen,
  shareConfigurationsViaSalesPartnerFinder,
  shareConfigurationsViaEmail,
}) => {
  const { t } = useTranslation();
  return (
    <SimpleMenu open={isOpen} anchorEl={anchorEl} onClose={onClose} {...MENU_POS_LEFT}>
      <MenuItem onClick={shareConfigurationsViaSalesPartnerFinder} className={"title-medium"}>
        {t("page.savedLinearConfigurations.table.button.share.name")}
      </MenuItem>
      <MenuItem className={"title-medium"} onClick={shareConfigurationsViaEmail}>
        {t("page.savedConfigs.shareViaEmail")}
      </MenuItem>
    </SimpleMenu>
  );
};

export default ShareConfigurationsMenu;
